<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fas fa-robot">
            <carta></carta>
        </c-panel>
    </div>
</template>
<script>
import carta from "./carta"
export default {
    components: { carta },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Assistente Virtual' }
}
</script>
